module.exports = __webpack_public_path__ + "assets/img/main-logo-cangzhou.e5fa4301.png";